import contentIcon from '@/assets/ic_content.svg'
import featureIcon from '@/assets/ic_feature.svg'
import calendarIcon from '@/assets/ic_calendar.svg'
import generalIcon from '@/assets/ic_info.svg'
import toolsIcon from '@/assets/ic_tools.svg'
import teachersTrainingIcon from '@/assets/ic_teachers-training.svg'

export const notificationsTags = {
  content: 1,
  feature: 2,
  maintenance: 3,
  ephemeride: 4,
  general: 5,
  teachersTraining: 6
}

export const notificationsTagsIcons = {
  [notificationsTags.content]: contentIcon,
  [notificationsTags.feature]: featureIcon,
  [notificationsTags.maintenance]: toolsIcon,
  [notificationsTags.ephemeride]: calendarIcon,
  [notificationsTags.general]: generalIcon,
  [notificationsTags.teachersTraining]: teachersTrainingIcon
}
